<div class="container-fluid">
  <app-pagetitle title="Contracts" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>
</div>

<div class="main-card-container">
  <div class="card">
    <div class="card-body">
      <div class="dropdown float-end" ngbDropdown > 
        <ng-container *ngIf="!readonly">           
        <a href="javascript: void(0);" class="dropdown-toggle arrow-none card-drop" ngbDropdownToggle
          data-toggle="dropdown" aria-expanded="false" >
          <i class="mdi mdi-dots-vertical"></i>
        </a>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu >
          <!-- item-->
          <a *ngIf="!readonly" href="javascript:void(0);" class="dropdown-item">Import Contract</a>
          <!-- item-->
          <a href="javascript:void(0);" class="dropdown-item">Export Contract</a>
        </div>
      </ng-container>   
        <i class="mdi mdi-refresh" (click)="refresh()" ngbTooltip="Refresh"></i>
      </div>
      <h4 class="card-title mb-4">Contract</h4>
      <div class="row">
        <button *ngIf="!readonly" type="button"  class="btn btn-primary" style="height:50px;width:200px;"  (click)="onAddNew(addEditModal)">Add New Contract</button>
        <div class="col-sm-12 col-md-12">
          <div id="tickets-table_filter" class="dataTables_filter text-md-end">
            <label class="d-inline-flex align-items-center">
              Search:
              <input 
                type="text" 
                name="searchTerm" 
                class="form-control form-control-sm ms-2"
                aria-controls="tickets-table" 
                [(ngModel)]="term" 
                (ngModelChange)="onSearch()" />
            </label>
          </div>
        </div>
      </div>
      <div class="table-responsive" style="max-height: 400px; overflow-y: auto;" >
        <table class="table table-centered">
            <thead class="table-light" style="position: sticky; top: 0; z-index: 1;">
            <tr>
              <th>Contract Tag</th>
              <th>Contract Company Name</th>
              <th>Number  of Machines/Boards</th>
              <th>Sales Rep</th>             
              <th>Street Address</th>             
              <th>City</th>
              <th>State</th>
              <th>Zip Code</th>
              <th>Country</th>
              <th>Contract Enabled</th>

            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of filteredLocation">
              <td>{{item.locationTag}}</td>
              <td>{{item.locationName}}</td>
              <td>{{item.numBoards}}</td>
              <td>{{item.salesRep?.firstName}}: {{item.salesRep?.lastName}}</td>
              <td>{{item.businessAddress.streetAddress1}}</td>
              <td>{{item.businessAddress.city}}</td>
              <td>{{item.businessAddress.state}}</td>
              <td>{{item.businessAddress.zipCode}}</td>
              <td>{{item.businessAddress.country}}</td>
              <td>
                <input *ngIf="!readonly; else isEnabled" type="checkbox" class="form-check-input" name="enabled"  [checked]="item.enabled"> 
                <ng-template #isEnabled>{{item.enabled}}</ng-template>
              </td> 
              <td>
                <div class="badge font-size-12">
                </div>
              </td>
              <td>
                <a *ngIf="!readonly"  (click)="onEdit(addEditModal, item)" class="me-3 text-primary" ngbTooltip="Edit" ><i
                    class="mdi mdi-pencil font-size-50"></i></a>
                <a *ngIf="!readonly" (click)="onDelete(item.id)"  class="text-danger" ngbTooltip="Delete"><i
                    class="mdi mdi-trash-can font-size-18"></i></a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <ng-template #addEditModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="add-edit-modal-title">{{addEditMode}}</h4>
      <button class="btn btn-warn close" (click)="modal.dismiss('Cross click')">Close</button>
    </div>
    <div class="form-group">
      

    </div>
    <div class="modal-body">
      <form class="form" [formGroup]="addEditFormGroup">
        <div class="form-group">
          <label for="locationName-input">Contract Company Name</label>
          <input type="text" class="form-control" id="locationName-input" 
            formControlName="locationName"
            aria-describedby="locationName" placeholder="Contract Company Name">
        </div>
        <div class="form-group">
          <label for="locationStartDate-input">Contract Start Date</label>
          <input type="date" class="form-control" id="locationStartDate-input" 
            formControlName="locationStartDate"
            aria-describedby="locationStartDate" placeholder="Contract Start Date">
        </div>
        <div class="form-group">
          <label for="locationEndtDate-input">Contract End Date</label>
          <input type="date" class="form-control" id="locationEndtDate-input" 
            formControlName="locationEndtDate"
            aria-describedby="locationEndtDate" placeholder="Contract End Date">
        </div>
        <div class="form-group">
          <label for="salesRep-input">Sales Rep</label>        
          <select class="form-select" id="salesRep-games-input"  formControlName="salesRep" (change)="onChange()">
              <option *ngFor="let v of salesReps" [value]="v.id">{{v.firstName}}{{v.lastName}}</option>
          </select>
        </div>
        <div formGroupName="businessAddress">
        <div class="form-group">
          <label for="streetAddress1-input">Street Address 1</label>
          <input type="text" class="form-control" id="streetAddress1-input" 
            formControlName="streetAddress1"
            aria-describedby="streetAddress1" placeholder="Street Address 1">
        </div>
        <div class="form-group">
          <label for="streetAddress2-input">Street Address 2</label>
          <input type="text" class="form-control" id="streetAddress2-input" 
            formControlName="streetAddress2"
            aria-describedby="streetAddress2" placeholder="Street Address 2">
        </div>
        <div class="form-group">
          <label for="city-input">City</label>
          <input type="text" class="form-control" id="city-input" 
            formControlName="city"
            aria-describedby="city" placeholder="Enter City">
        </div>
        
          <div class="form-group">
            <label for="state-input">State</label>
            <input type="text" class="form-control" id="state-input" 
              formControlName="state"
              aria-describedby="state" placeholder="Enter State">
          </div>
          <div class="form-group">
            <label for="zipCode-input">Zip Code</label>
            <input type="text" class="form-control" id="zipCode-input" 
              formControlName="zipCode"
              aria-describedby="zipCode" placeholder="Enter Zip Code">
          </div>
          <div class="form-group">
            <label for="country-input">Country</label>
            <input type="text" class="form-control" id="country-input" 
              formControlName="country"
              aria-describedby="country" placeholder="Enter Country">
          </div>       
        </div>
        <div class="form-group">
          <label for="enabled-input" style="font-size: 20px;" style="font-family: Arial;">Enabled</label >
        
          <input type="checkbox" class="form-check-input" id="enabled-input"  style="height:25px;width:25px;"
            formControlName="enabled" >
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button class="btn btn-primary btn-outline-dark" style="height:50px;width:200px;"  (click)="modal.close('Save click')">Save</button>
    </div>
  </ng-template>
</div>